import { render, staticRenderFns } from "./currency-switch.vue?vue&type=template&id=b80b1840&scoped=true"
import script from "./currency-switch.vue?vue&type=script&lang=js"
export * from "./currency-switch.vue?vue&type=script&lang=js"
import style0 from "./currency-switch.vue?vue&type=style&index=0&id=b80b1840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80b1840",
  null
  
)

export default component.exports